(() => {
  const body = document.body;
  const installPrompt = document.querySelector('[data-openclaw-install]');
  const installMessage = document.querySelector('[data-openclaw-install-message]');
  const installAction = document.querySelector('[data-openclaw-install-action]');
  const installDismiss = document.querySelector('[data-openclaw-install-dismiss]');
  const navLinks = document.querySelectorAll('[data-openclaw-nav]');
  const openMenuButton = document.querySelector('[data-openclaw-open-menu]');
  const backButton = document.querySelector('[data-openclaw-back]');
  const sessionDismissKey = 'openclaw-install-dismissed-session-v1';
  const installedKey = 'openclaw-install-installed-v1';
  let deferredPrompt = null;

  const refreshWhatsAppLinks = () => {
    document.querySelectorAll('a[href="https://wa.me/15559212001"]').forEach((link) => {
      link.setAttribute('href', 'https://wa.me/584242506743');
    });
  };

  refreshWhatsAppLinks();
  document.addEventListener('shopify:section:load', refreshWhatsAppLinks);

  const isStandalone = () => {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  };

  const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
  const isSafari = () => /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);

  const setStandaloneState = () => {
    body.dataset.openclawStandalone = isStandalone() ? 'true' : 'false';
    refreshBackButton();
  };

  const refreshBackButton = () => {
    if (!backButton) return;
    const isHome = window.location.pathname === '/' || window.location.pathname === '';
    const isMobileViewport = window.matchMedia('(max-width: 989px)').matches;
    backButton.hidden = !isMobileViewport || isHome;
  };

  const goBack = () => {
    const referrer = document.referrer ? new URL(document.referrer, window.location.origin) : null;
    const hasSameOriginReferrer = referrer?.origin === window.location.origin;

    if (window.history.length > 1 || hasSameOriginReferrer) {
      window.history.back();
      return;
    }

    window.location.href = '/';
  };

  const getActiveNav = (pathname) => {
    if (pathname === '/' || pathname === '') return 'home';
    if (pathname.startsWith('/collections')) return 'collections';
    if (pathname.startsWith('/search')) return 'search';
    if (pathname.startsWith('/account')) return 'account';
    if (pathname.startsWith('/cart')) return 'cart';
    return 'home';
  };

  const highlightActiveNav = () => {
    const active = getActiveNav(window.location.pathname);
    navLinks.forEach((link) => {
      const isActive = link.dataset.openclawNav === active;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const markStickyAddToCart = () => {
    const stickyAtc = document.querySelector('sticky-add-to-cart, .sticky-add-to-cart, [data-sticky-add-to-cart]');
    body.classList.toggle('openclaw-has-sticky-atc', Boolean(stickyAtc));
  };

  const promptDismissed = () => {
    return window.sessionStorage.getItem(sessionDismissKey) === '1' || window.localStorage.getItem(installedKey) === '1';
  };

  const hidePrompt = () => {
    if (!installPrompt) return;
    installPrompt.hidden = true;
    installPrompt.style.display = 'none';
  };

  const showPrompt = (message, actionLabel, mode = 'install') => {
    if (!installPrompt || promptDismissed() || isStandalone()) return;
    if (installMessage && message) installMessage.textContent = message;
    if (installAction) {
      if (actionLabel) installAction.textContent = actionLabel;
      installAction.dataset.openclawMode = mode;
    }
    installPrompt.hidden = false;
    installPrompt.style.display = 'block';
  };

  const dismissPrompt = () => {
    window.sessionStorage.setItem(sessionDismissKey, '1');
    hidePrompt();
  };

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event;
    showPrompt('Instala FUSFIT para abrir la tienda como app y volver más rápido.', 'Instalar');
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    window.localStorage.setItem(installedKey, '1');
    hidePrompt();
  });

  installAction?.addEventListener('click', async () => {
    const mode = installAction.dataset.openclawMode || 'install';

    if (mode === 'dismiss') {
      dismissPrompt();
      return;
    }

    if (mode === 'ios-help') {
      showPrompt('En Safari, toca Compartir y luego “Agregar a pantalla de inicio”.', 'Entendido', 'dismiss');
      return;
    }

    if (deferredPrompt) {
      deferredPrompt.prompt();
      try {
        const choice = await deferredPrompt.userChoice;
        if (choice?.outcome === 'accepted') {
          window.localStorage.setItem(installedKey, '1');
        } else {
          window.sessionStorage.setItem(sessionDismissKey, '1');
        }
      } catch (error) {
        console.debug('Install prompt closed', error);
        window.sessionStorage.setItem(sessionDismissKey, '1');
      }
      deferredPrompt = null;
      hidePrompt();
      return;
    }

    if (isIos() && isSafari()) {
      showPrompt('En Safari, toca Compartir y luego “Agregar a pantalla de inicio”.', 'Entendido', 'dismiss');
      return;
    }

    dismissPrompt();
  });

  installDismiss?.addEventListener('click', dismissPrompt);

  backButton?.addEventListener('click', goBack);

  openMenuButton?.addEventListener('click', () => {
    const summary = document.querySelector('#Details-menu-drawer-container > summary, .menu-drawer-container > summary, summary.header__icon--menu');
    if (summary instanceof HTMLElement) {
      summary.click();
      return;
    }
    window.location.href = '/collections/all';
  });

  setStandaloneState();
  highlightActiveNav();
  markStickyAddToCart();

  window.addEventListener('resize', () => {
    setStandaloneState();
    markStickyAddToCart();
  });

  window.matchMedia('(display-mode: standalone)').addEventListener?.('change', setStandaloneState);
  window.addEventListener('pageshow', refreshBackButton);

  if (!promptDismissed() && isIos() && isSafari() && !isStandalone()) {
    showPrompt('Añade FUSFIT a tu pantalla de inicio desde Safari para usarla como app.', 'Cómo hacerlo', 'ios-help');
  }
})();

(function () {
  // Coalesce ráfagas de mutaciones (Horizon re-renderiza todo el carrito al cambiar cantidad)
  // en una sola pasada por frame, para evitar querySelectors repetidos y jank.
  function rafDebounce(fn) {
    var scheduled = false;
    return function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () { scheduled = false; fn(); });
    };
  }

  function cleanCoupon(value) {
    return String(value || '').trim().toUpperCase().replace(/[^A-Z0-9_-]/g, '').slice(0, 40);
  }

  function discountRedirect(code, redirectPath) {
    var safeCode = cleanCoupon(code);
    if (!safeCode) return '';
    var target = redirectPath || (window.location.pathname + window.location.search);
    return '/discount/' + encodeURIComponent(safeCode) + '?redirect=' + encodeURIComponent(target || '/cart');
  }

  function autoApplyCouponFromUrl() {
    var params = new URLSearchParams(window.location.search || '');
    var code = cleanCoupon(params.get('discount') || params.get('coupon') || params.get('cupon'));
    if (!code) return;
    if (window.location.pathname.indexOf('/discount/') === 0) return;
    params.delete('discount');
    params.delete('coupon');
    params.delete('cupon');
    var redirect = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.location.replace(discountRedirect(code, redirect));
  }

  function setupCouponReminder(root) {
    (root || document).querySelectorAll('[data-fusfit-coupon-form]').forEach(function (form) {
      if (form.dataset.fusfitCouponBound === '1') return;
      form.dataset.fusfitCouponBound = '1';
      var input = form.querySelector('[data-fusfit-coupon-input]');
      if (!input) return;

      input.addEventListener('input', function () {
        input.value = cleanCoupon(input.value);
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var url = discountRedirect(input.value, '/cart');
        if (url) window.location.href = url;
      });
    });
  }

  function setupCheckoutCouponGuard(root) {
    (root || document).querySelectorAll('#checkout, .cart__checkout-button').forEach(function (button) {
      if (button.dataset.fusfitCouponCheckoutBound === '1') return;
      button.dataset.fusfitCouponCheckoutBound = '1';
      button.addEventListener('click', function (event) {
        var reminder = document.querySelector('[data-fusfit-coupon-reminder]');
        var input = reminder && reminder.querySelector('[data-fusfit-coupon-input]');
        var code = input ? cleanCoupon(input.value) : '';
        if (!code) return;
        event.preventDefault();
        event.stopPropagation();
        window.location.href = discountRedirect(code, '/checkout');
      }, true);
    });
  }

  var _rewardsBlockCache = null;
  function findRewardsLoginBlock() {
    // El TreeWalker recorre TODOS los nodos de texto → memorizamos el bloque hallado para no repetirlo.
    if (_rewardsBlockCache && document.body.contains(_rewardsBlockCache)) return _rewardsBlockCache;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.indexOf('Inicia sesión para canjear puntos') === -1) continue;
      var target = node.parentElement;
      if (!target || target.closest('script, style, template, [data-fusfit-coupon-reminder]')) continue;
      while (
        target.parentElement &&
        target.parentElement !== document.body &&
        !target.parentElement.matches('.cart-page, .cart-page__more-blocks, .cart-page__items, .cart-items__wrapper, .cart-page__summary')
      ) {
        target = target.parentElement;
      }
      _rewardsBlockCache = target;
      return target;
    }
    return null;
  }

  function findDeliveryDateBlock() {
    var summary = document.querySelector('.cart-page__summary, .cart__summary, .cart-actions') || document.body;
    var nodes = summary.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (node.closest('[data-fusfit-coupon-reminder]')) continue;
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.indexOf('Servicio disponible') === -1 || text.indexOf('Selecciona una fecha') === -1) continue;
      var target = node;
      while (
        target.parentElement &&
        target.parentElement !== summary &&
        target.parentElement.textContent &&
        target.parentElement.textContent.indexOf('Servicio disponible') !== -1 &&
        target.parentElement.textContent.indexOf('Selecciona una fecha') !== -1
      ) {
        target = target.parentElement;
      }
      return target;
    }
    var seTarget = document.getElementById('se_display_target');
    if (seTarget && seTarget.nextElementSibling && !seTarget.nextElementSibling.matches('[data-fusfit-coupon-reminder], [data-fusfit-cart-items-coupon]')) {
      return seTarget.nextElementSibling;
    }
    return null;
  }

  function placeCouponInCartFlow() {
    var wrapper = document.querySelector('[data-fusfit-cart-items-coupon]');
    var reminder = wrapper || document.querySelector('[data-fusfit-coupon-reminder]');
    if (!reminder || !reminder.parentNode) return;

    var isDesktop = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
    if (isDesktop) {
      var deliveryDate = findDeliveryDateBlock();
      if (deliveryDate && deliveryDate.parentNode && deliveryDate.nextElementSibling !== reminder) {
        deliveryDate.parentNode.insertBefore(reminder, deliveryDate.nextSibling);
        return;
      }
    }

    var rewards = findRewardsLoginBlock();
    if (rewards && rewards.parentNode && reminder.nextElementSibling !== rewards) {
      rewards.parentNode.insertBefore(reminder, rewards);
      return;
    }

    var cartNote = document.querySelector('.cart-note, cart-note, .cart-note__summary');
    var noteTarget = cartNote && (cartNote.closest('.cart-actions') || cartNote.closest('cart-note') || cartNote);
    if (noteTarget && noteTarget.parentNode && reminder.nextElementSibling !== noteTarget) {
      noteTarget.parentNode.insertBefore(reminder, noteTarget);
    }
  }

  function scheduleCartFlowPlacement() {
    if (document.documentElement.dataset.fusfitCouponPlacementScheduled === '1') return;
    document.documentElement.dataset.fusfitCouponPlacementScheduled = '1';

    [0, 300, 800, 1500, 3000, 5000].forEach(function (delay) {
      window.setTimeout(placeCouponInCartFlow, delay);
    });
  }


  function normalizeDivisasChoice(value) {
    var normalized = String(value || '').trim().toLowerCase();
    if (!normalized) return '';
    if (normalized.indexOf('paypal') !== -1 || normalized.indexOf('pay pal') !== -1) return 'paypal';
    if (normalized === 'bs' || normalized.indexOf('bolivar') !== -1 || normalized.indexOf('bolívar') !== -1 || normalized.indexOf('pago movil') !== -1 || normalized.indexOf('pago móvil') !== -1 || normalized.indexOf('transferencia') !== -1) return 'bs';
    if (normalized.indexOf('zelle') !== -1) return 'zelle';
    if (normalized.indexOf('usdt') !== -1) return 'usdt';
    if (normalized.indexOf('efectivo') !== -1 || normalized.indexOf('divisa') !== -1 || normalized.indexOf('usd') !== -1 || normalized.indexOf('dolar') !== -1) return 'efectivo_divisas';
    return normalized;
  }

  function divisasDiscountGuard(choice) {
    return ['efectivo_divisas', 'zelle', 'usdt'].indexOf(normalizeDivisasChoice(choice)) !== -1 ? '15' : '0';
  }

  function placePaymentPanelBeforeCheckout() {
    var panel = document.querySelector('[data-fusfit-divisas-panel]');
    var checkout = document.querySelector('#checkout, .cart__checkout-button[name="checkout"]');
    if (!panel || !checkout) return;

    var ctas = checkout.closest('.cart__ctas') || checkout.parentElement;
    if (!ctas || !ctas.parentNode) return;

    // Orden deseado: ... recomendaciones (app) -> métodos de pago -> botón Pagar.
    // El app de recomendaciones inyecta su card justo antes de .cart__ctas. Si ya está,
    // ponemos el panel de pago JUSTO DESPUÉS de esa card (idempotente: no mueve si ya está bien).
    var reco = document.querySelector('[data-fusfit-recomendations-cart], [data-fusfit-recomendations-auto="cart-checkout"]');
    if (reco && reco.parentNode) {
      if (reco.nextElementSibling !== panel) {
        reco.parentNode.insertBefore(panel, reco.nextSibling);
      }
      return;
    }

    // Fallback (aún no llega la reco): antes del botón checkout.
    if (panel.nextElementSibling !== ctas) {
      ctas.parentNode.insertBefore(panel, ctas);
    }
  }

  function schedulePaymentPanelPlacement() {
    // Intentos idempotentes para agarrar la card de reco cuando el app la inyecte (async),
    // sin flicker (solo mueve si la posición está mal).
    [0, 400, 900, 1800, 3500, 6000].forEach(function (delay) {
      window.setTimeout(placePaymentPanelBeforeCheckout, delay);
    });
    if (window.MutationObserver) {
      var obs = new MutationObserver(function () { placePaymentPanelBeforeCheckout(); });
      try { obs.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
      window.setTimeout(function () { obs.disconnect(); }, 8000);
    }
  }

  function setupDivisasPaymentPreference(root) {
    var scope = root || document;
    var panels = scope.querySelectorAll('[data-fusfit-divisas-panel]');
    if (!panels.length) return;

    function checkoutButtons() {
      return Array.prototype.slice.call(document.querySelectorAll('#checkout, .cart__checkout-button[name="checkout"]'));
    }

    function setCheckoutLocked(panel, locked) {
      checkoutButtons().forEach(function (button) {
        if (!button) return;
        if (!button.dataset.fusfitOriginalType) {
          button.dataset.fusfitOriginalType = button.getAttribute('type') || 'submit';
        }
        if (locked) {
          button.dataset.fusfitPaymentLocked = '1';
          button.setAttribute('aria-disabled', 'true');
          button.classList.add('is-payment-locked');
          button.setAttribute('type', 'button');
        } else {
          delete button.dataset.fusfitPaymentLocked;
          button.removeAttribute('aria-disabled');
          button.classList.remove('is-payment-locked');
          button.setAttribute('type', button.dataset.fusfitOriginalType || 'submit');
        }
      });
      panel.dataset.fusfitHasChoice = locked ? '0' : '1';
    }

    function showSelectPaymentNotice(panel) {
      var status = panel.querySelector('[data-fusfit-divisas-status]');
      if (!status) return;
      status.textContent = 'Debes seleccionar primero el método de pago.';
      panel.classList.add('is-payment-warning');
      window.clearTimeout(panel._fusfitWarningTimeout);
      panel._fusfitWarningTimeout = window.setTimeout(function () {
        panel.classList.remove('is-payment-warning');
      }, 2200);
    }

    function bindCheckoutGuard(panel) {
      checkoutButtons().forEach(function (button) {
        if (!button || button.dataset.fusfitPaymentGuardBound === '1') return;
        button.dataset.fusfitPaymentGuardBound = '1';
        button.addEventListener('click', function (event) {
          if (panel.dataset.fusfitHasChoice === '1') return;
          event.preventDefault();
          event.stopPropagation();
          showSelectPaymentNotice(panel);
          panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, true);
      });

      var form = document.getElementById('cart-form');
      if (form && form.dataset.fusfitPaymentGuardBound !== '1') {
        form.dataset.fusfitPaymentGuardBound = '1';
        form.addEventListener('submit', function (event) {
          if (panel.dataset.fusfitHasChoice === '1') return;
          event.preventDefault();
          event.stopPropagation();
          showSelectPaymentNotice(panel);
          panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, true);
      }
    }

    function updatePanel(panel, choice, label, message) {
      var normalized = normalizeDivisasChoice(choice);
      panel.querySelectorAll('[data-fusfit-divisas-choice]').forEach(function (button) {
        var active = normalizeDivisasChoice(button.getAttribute('data-fusfit-divisas-choice')) === normalized;
        button.dataset.active = active ? 'true' : 'false';
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var status = panel.querySelector('[data-fusfit-divisas-status]');
      if (status) {
        status.textContent = message || (label ? ('Método seleccionado: ' + label) : 'Sin método seleccionado.');
      }
      setCheckoutLocked(panel, !normalized);
      bindCheckoutGuard(panel);
    }

    function readCurrent(panel) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.attributes) return;
          updatePanel(panel, cart.attributes.payment_preference, cart.attributes.payment_preference_label);
        })
        .catch(function () {});
    }

    // Watcher por EVENTO (reemplaza los timeouts fijos): re-aplica el estado correcto del botón Pagar
    // en el instante exacto en que Horizon re-renderiza/reemplaza el botón (morph async), sin importar
    // cuánto tarde en móvil. Fuente de verdad de "ya eligió método": el panel (data-fusfit-has-choice)
    // o la elección de esta sesión (window.__fusfitDivisasChoice), para que NO se vuelva a bloquear.
    function ensureCheckoutLockWatcher() {
      if (document.documentElement.dataset.fusfitCheckoutLockWatcher === '1') return;
      document.documentElement.dataset.fusfitCheckoutLockWatcher = '1';
      function currentPanel() { return document.querySelector('[data-fusfit-divisas-panel]'); }
      function wantsUnlock(p) { return (p && p.dataset.fusfitHasChoice === '1') || !!window.__fusfitDivisasChoice; }
      function reapply() {
        var p = currentPanel();
        if (!p) return;
        setCheckoutLocked(p, !wantsUnlock(p));
        bindCheckoutGuard(p);
      }
      var watch = rafDebounce(function () {
        var p = currentPanel();
        var btn = document.querySelector('#checkout, .cart__checkout-button[name="checkout"]');
        if (!p || !btn) return;
        var want = wantsUnlock(p);
        var isUnlocked = !btn.classList.contains('is-payment-locked') && btn.getAttribute('aria-disabled') !== 'true';
        // Solo tocar el DOM cuando el estado está mal (evita pelear con el morph / flicker).
        if (want !== isUnlocked || btn.dataset.fusfitPaymentGuardBound !== '1') reapply();
      });
      document.addEventListener('cart:update', reapply);
      try { new MutationObserver(watch).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    }

    panels.forEach(function (panel) {
      if (panel.dataset.fusfitDivisasBound === '1') return;
      panel.dataset.fusfitDivisasBound = '1';
      // Si el panel se re-renderiza y el server-choice viene vacío (stale), caemos a la elección hecha en
      // esta sesión (window.__fusfitDivisasChoice) para NO re-bloquear el botón tras elegir método.
      var __srvChoice = panel.dataset.fusfitServerChoice || window.__fusfitDivisasChoice || '';
      var __srvBtn = __srvChoice ? panel.querySelector('[data-fusfit-divisas-choice="' + __srvChoice + '"]') : null;
      updatePanel(panel, __srvChoice, __srvBtn ? (__srvBtn.getAttribute('data-fusfit-divisas-label') || '') : '');
      bindCheckoutGuard(panel);
      ensureCheckoutLockWatcher();
      // El servidor ya inyecta la elección (data-fusfit-server-choice); solo consultamos /cart.js
      // como respaldo cuando no vino, para evitar un round-trip innecesario al cargar el carrito.
      if (!__srvChoice) readCurrent(panel);

      panel.addEventListener('click', function (event) {
        var button = event.target.closest('[data-fusfit-divisas-choice]');
        if (!button || !panel.contains(button)) return;

        var choice = normalizeDivisasChoice(button.getAttribute('data-fusfit-divisas-choice'));
        var label = button.getAttribute('data-fusfit-divisas-label') || button.textContent.trim();
        if (!choice) return;

        panel.querySelectorAll('[data-fusfit-divisas-choice]').forEach(function (item) { item.disabled = true; });
        updatePanel(panel, choice, label, 'Guardando método de pago...');

        var form = new FormData();
        form.append('attributes[payment_preference]', choice);
        form.append('attributes[payment_preference_label]', label);
        form.append('attributes[divisas_discount_guard]', divisasDiscountGuard(choice));

        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: form,
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('No se pudo guardar la preferencia.');
            return response.json();
          })
          .then(function () {
            panel.querySelectorAll('[data-fusfit-divisas-choice]').forEach(function (item) { item.disabled = false; });
            // Refresco NATIVO de Horizon: <cart-items-component> escucha 'discount:update' y re-renderiza
            // el total con el descuento de divisas aplicado, SIN recargar la página.
            // Si el componente no está, caemos al recargar (el total siempre queda correcto).
            if (document.querySelector('cart-items-component')) {
              window.__fusfitDivisasChoice = choice;
              window.__fusfitDivisasLabel = label;
              updatePanel(panel, choice, label, 'Método seleccionado: ' + label);
              document.dispatchEvent(new CustomEvent('discount:update', {
                bubbles: true,
                detail: { data: { sections: {} }, source: 'fusfit-divisas' }
              }));
              // El re-render de Horizon reemplaza el botón Pagar por uno nuevo. En vez de adivinar con
              // timeouts fijos (frágil en móvil), el watcher por evento re-aplica el desbloqueo en el
              // instante exacto en que aparece el botón nuevo. Idempotente.
              ensureCheckoutLockWatcher();
            } else {
              updatePanel(panel, choice, label, 'Actualizando total...');
              window.setTimeout(function () { window.location.reload(); }, 150);
            }
          })
          .catch(function () {
            updatePanel(panel, choice, label, 'No pudimos guardar el método. Intenta de nuevo antes de pagar.');
            panel.querySelectorAll('[data-fusfit-divisas-choice]').forEach(function (item) { item.disabled = false; });
          });
      });
    });

    if (!document.documentElement.dataset.fusfitDivisasReobserve) {
      document.documentElement.dataset.fusfitDivisasReobserve = '1';
      try {
        new MutationObserver(rafDebounce(function () {
          if (document.querySelector('[data-fusfit-divisas-panel]:not([data-fusfit-divisas-bound])')) {
            setupDivisasPaymentPreference(document);
            placePaymentPanelBeforeCheckout();
          }
        })).observe(document.body, { childList: true, subtree: true });
      } catch (e) {}
    }
  }

  function isCartPage() {
    if (document.body && document.body.classList.contains('template-cart')) return true;
    return window.location.pathname.replace(/\/+$/, '') === '/cart';
  }

  function removeCustomCouponNodesOnCart() {
    document.querySelectorAll('[data-fusfit-coupon-reminder], [data-fusfit-cart-items-coupon]').forEach(function (node) {
      if (node && node.remove) node.remove();
    });
  }

  function enforceNoCustomCouponOnCart() {
    if (document.documentElement.dataset.fusfitCartCouponObserverBound === '1') return;
    document.documentElement.dataset.fusfitCartCouponObserverBound = '1';

    removeCustomCouponNodesOnCart();

    var observer = new MutationObserver(rafDebounce(removeCustomCouponNodesOnCart));

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function bootCouponVisibility(root) {
    setupDivisasPaymentPreference(root);
    placePaymentPanelBeforeCheckout();
    schedulePaymentPanelPlacement();

    if (isCartPage()) {
      removeCustomCouponNodesOnCart();
      enforceNoCustomCouponOnCart();
      return;
    }

    setupCouponReminder(root);
    setupCheckoutCouponGuard(root);
    placeCouponInCartFlow();
    scheduleCartFlowPlacement();
  }

  autoApplyCouponFromUrl();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootCouponVisibility(document); });
  } else {
    bootCouponVisibility(document);
  }
  document.addEventListener('cart:update', function () { bootCouponVisibility(document); });
  document.addEventListener('shopify:section:load', function (event) { bootCouponVisibility(event.target || document); });
})();

